import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  ViagensJustificationCreationPage,
  ViagensJustificationsListPage,
  ViagensJustificationUpdatePage,
} from 'pages/viagens-justifications/viagens-justifications-list-page';

export default ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/justificativas-estadia',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    { path: '', element: <ViagensJustificationsListPage /> },
    { path: 'criar', element: <ViagensJustificationCreationPage /> },
    { path: ':id/editar', element: <ViagensJustificationUpdatePage /> },
  ],
});
